/* Cammarata Mode — ascending sizes on PDP, dropdowns, cards.
   Visual DOM order only: Shopify variant ids, values, availability and
   selected states remain the same. No automatic clicks or change events. */
(function () {
  'use strict';
  if (window.__cmAscendingSizesInstalled) return;
  window.__cmAscendingSizesInstalled = true;

  var collator = new Intl.Collator('it', { numeric: true, sensitivity: 'base' });
  var alphabetic = {
    'XXXS': 1, '3XS': 1, 'XXS': 2, '2XS': 2, 'XS': 3,
    'S': 4, 'SM': 4.5, 'S/M': 4.5, 'M': 5, 'ML': 5.5,
    'M/L': 5.5, 'L': 6, 'LXL': 6.5, 'L/XL': 6.5,
    'XL': 7, 'XXL': 8, '2XL': 8, 'XXXL': 9, '3XL': 9,
    '4XL': 10, '5XL': 11, '6XL': 12
  };
  function orderOf(text) {
    var raw = String(text || '').normalize('NFKC').toUpperCase().trim()
      .replace(/\b(MESI|MESE)\b/g, 'M')
      .replace(/\b(ANNI|ANNO)\b/g, 'A')
      .replace(/[\u00a0\s]+/g, '');
    raw = raw.split('(')[0].split('|')[0];
    if (Object.prototype.hasOwnProperty.call(alphabetic, raw))
      return [3, alphabetic[raw], raw];
    if (/^(UNICA|UNI|TU|ONESIZE|OS|UNIQUE)$/.test(raw))
      return [4, 0, raw];
    var numeric = raw.match(/^(\d+(?:[.,]\d+)?)(?:[-/](\d+(?:[.,]\d+)?))?(M|A|Y|CM|IT|EU)?(?:\b|$)/);
    if (numeric) {
      var number = Number(numeric[1].replace(',', '.'));
      var suffix = numeric[3] || '';
      if (Number.isFinite(number)) {
        if (suffix === 'M') return [0, number, raw];
        if (suffix === 'A' || suffix === 'Y') return [1, number, raw];
        return [2, number, raw];
      }
    }
    return [5, 0, raw];
  }
  function compareSizes(a, b) {
    var x = orderOf(a), y = orderOf(b);
    return x[0] - y[0] || x[1] - y[1] || collator.compare(x[2], y[2]);
  }
  function isSizeName(name) {
    return /taglia|size|misura|numero|shoe size|calzata/i.test(name || '');
  }
  function sortRadioGroup(fieldset) {
    var legend = fieldset.querySelector(':scope > legend');
    if (!legend || !isSizeName(legend.textContent)) return;
    var inputs = Array.from(fieldset.children)
      .filter(function (el) { return el.matches('input[type="radio"]'); });
    if (inputs.length < 2) return;
    var pairs = inputs.map(function (input, index) {
      var label = input.nextElementSibling;
      if (!label || label.tagName !== 'LABEL' || label.htmlFor !== input.id) return null;
      return { input: input, label: label, index: index };
    });
    if (pairs.some(function (item) { return !item; })) return;
    var sorted = pairs.slice().sort(function (a, b) {
      return compareSizes(a.input.value, b.input.value) || a.index - b.index;
    });
    if (pairs.every(function (item, i) { return item === sorted[i]; })) return;
    var selected = pairs.find(function (pair) { return pair.input.checked; });
    var fragment = document.createDocumentFragment();
    sorted.forEach(function (pair) {
      fragment.appendChild(pair.input);
      fragment.appendChild(pair.label);
    });
    fieldset.appendChild(fragment);
    if (selected) selected.input.checked = true;
  }
  function sortDropdown(wrapper) {
    var label = wrapper.querySelector(':scope > label');
    var select = wrapper.querySelector('select');
    if (!select || !isSizeName(label ? label.textContent : select.name)) return;
    var opts = Array.from(select.options);
    if (opts.length < 2 || opts.length !== select.children.length) return;
    var saved = select.selectedOptions[0] || null;
    var sorted = opts.map(function (option, index) { return { option: option, index: index }; })
      .sort(function (a, b) {
        return compareSizes(a.option.value, b.option.value) || a.index - b.index;
      });
    if (opts.every(function (node, i) { return node === sorted[i].option; })) return;
    var fragment = document.createDocumentFragment();
    sorted.forEach(function (item) { fragment.appendChild(item.option); });
    select.appendChild(fragment);
    if (saved) saved.selected = true;
  }
  function sortCardBadges(container) {
    var badges = Array.from(container.children)
      .filter(function (node) { return node.classList.contains('size-pill'); });
    if (badges.length < 2) return;
    var sorted = badges.map(function (node, index) { return { node: node, index: index }; })
      .sort(function (a, b) {
        return compareSizes(a.node.textContent, b.node.textContent) || a.index - b.index;
      });
    if (badges.every(function (node, i) { return node === sorted[i].node; })) return;
    var fragment = document.createDocumentFragment();
    sorted.forEach(function (item) { fragment.appendChild(item.node); });
    container.appendChild(fragment);
  }
  function sortAll() {
    document.querySelectorAll('variant-selects fieldset.product-form__input--pill, variant-selects fieldset.product-form__input--swatch')
      .forEach(sortRadioGroup);
    document.querySelectorAll('variant-selects .product-form__input--dropdown')
      .forEach(sortDropdown);
    document.querySelectorAll('.card-variant-sizes')
      .forEach(sortCardBadges);
  }
  function start() {
    sortAll();
    var scheduled = false;
    var observer = new MutationObserver(function (records) {
      var changed = records.some(function (record) {
        var el = record.target;
        if (el.nodeType === 1 && el.closest &&
            (el.closest('variant-selects') || el.closest('.card-variant-sizes'))) return true;
        return Array.from(record.addedNodes).some(function (node) {
          if (node.nodeType !== 1) return false;
          return (node.matches && node.matches('variant-selects, .card-variant-sizes, product-info')) ||
            (node.querySelector && !!node.querySelector('variant-selects, .card-variant-sizes'));
        });
      });
      if (!changed || scheduled) return;
      scheduled = true;
      queueMicrotask(function () { scheduled = false; sortAll(); });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', sortAll);
    window.addEventListener('pageshow', sortAll);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
